import axios from "axios";
import moment from "moment/moment";
import React, { useEffect, useMemo, useReducer, useState } from "react";
import { IoInformationCircleOutline, IoRefresh } from "react-icons/io5";

import { IoMdRefresh } from "react-icons/io";
import Swal from "sweetalert2";
import { FadeLoader } from "react-spinners";
import { FaCross } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
// import { ResendModal } from "./Tab2Components/ResendModal";
import { Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import socket from "../../../context/socket";
import { useSearchParams } from "react-router-dom";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";

export const Tab2 = ({ roomId, isViewArchivedEvent }) => {
  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);
  const [searchParams] = useSearchParams();

  const goalId = searchParams.get("goalEventId");

  const [isArchivedEvent, setIsArchivedEvent] = useState([]); // Default to an empty array
  const [selectAll, setSelectAll] = useState(true);
  // console.log("isArchivedEvent", isArchivedEvent, isViewArchivedEvent, clientData);
  console.log("selectAll", selectAll, isArchivedEvent);


  const [isPostponed, setIsPostponed] = useState(false);
  const [sipStartTotal, setSipStartTotal] = useState(0);

  const [lumpsumAmountTotal, setLumpsumAmountTotal] = useState(0);

  const [sipStopTotal, setSipStopTotal] = useState(0);
  const [redeemAmountTotal, setRedeemAmountTotal] = useState(0);
  const [stpAmountTotal, setStpAmountTotal] = useState(0);

  // Define if not imported
  const groupByGoal = (folios) => {
    return folios.reduce((acc, folio) => {
      const goal = folio.goal_name || 'Unmapped Folio';
      if (!acc[goal]) acc[goal] = [];
      acc[goal].push(folio);
      return acc;
    }, {});
  };

  const groupedFolios = useMemo(() => groupByGoal(isArchivedEvent), [isArchivedEvent]);





  const [groupedFoliosState, setGroupedFoliosState] = useState({});

  useEffect(() => {
    if (!groupedFolios || Object.keys(groupedFolios).length === 0) return;

    const copied = {};
    Object.entries(groupedFolios).forEach(([goal, folios]) => {
      copied[goal] = folios.map((f) => ({
        ...f,
        isChecked: f.isChecked || false,
      }));
    });

    setGroupedFoliosState(copied);
  }, [groupedFolios]);


  useEffect(() => {
    const fetchArchivedEvent = async () => {

      try {
        // setLoading(true);
        Swal.fire({
          text: "Please wait...",
          imageUrl: "https://www.finedge.in/assets/images/download.gif",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        const response = await api.post(
          `advisor/getArchivedEvent`,
          { eventId: goalId }
        );

        setIsArchivedEvent(
          response.data?.transactionForms.map((item) => ({
            ...item,
            isChecked: true,
          }))
        );

      } catch (err) {
      } finally {
        // setLoading(false);
        Swal.close();
      }
    };

    fetchArchivedEvent();
  }, [isViewArchivedEvent]);





  // Set goalEventId based on the first item of isArchivedEvent
  // useEffect(() => {
  //   if (isArchivedEvent.length > 0) {
  //     setGoalEventId(isArchivedEvent[0].pr_id);
  //   }
  // }, [isArchivedEvent]);

  // Calculate and update totalAmount by iterating over isArchivedEvent
  // useEffect(() => {
  //   let sipStart = 0;
  //   let sipStop = 0;
  //   let stpAmount = 0;
  //   let redeemAmount = 0;
  //   let lumpsumAmount = 0;
  //   let sipStartTotal = 0;
  //   let stpAmountTotal = 0;
  //   let sipStopTotal = 0;
  //   let redeemAmountTotal = 0;
  //   let lumpsumAmountTotal = 0;
  //   let totalAmount = 0;
  //   let goalName = null;

  //   isArchivedEvent.forEach((folio) => {
  //     console.log("folio", folio);
  //     setIsEventId(folio.eventId);
  //     if (folio.tran_form_type == "SIP" && folio.trans_status != "Discarded") {
  //       setSipStart(folio.tran_no_of_unites);
  //       setSipStartTotal(folio.tran_no_of_unites);
  //       if (
  //         folio.trans_status == "Processing" ||
  //         folio.trans_status == "Failed" ||
  //         folio.trans_status == "Pending" ||
  //         folio.trans_status == "Rejected"
  //       ) {
  //         setArchivable(false);
  //       }
  //     } else if (
  //       folio.tran_form_type == "ReInvest" &&
  //       folio.trans_status != "Discarded"
  //     ) {
  //       // lumpsumTest = folio.tran_no_of_unites;
  //       lumpsumAmount += folio.tran_no_of_unites;
  //       setLumpsumAmountTotal(folio.tran_no_of_unites);
  //       if (
  //         folio.trans_status == "Processing" ||
  //         folio.trans_status == "Pending" ||
  //         folio.trans_status == "Failed"
  //       ) {
  //         setArchivable(false);
  //       }
  //     } else if (
  //       folio.tran_form_type == "Stop_sip" &&
  //       folio.trans_status != "Discarded"
  //     ) {
  //       sipStop += folio.tran_no_of_unites;
  //       setSipStopTotal(folio.tran_no_of_unites);
  //       if (
  //         folio.trans_status == "Processing" ||
  //         folio.trans_status == "Failed" ||
  //         folio.trans_status == "Pending" ||
  //         folio.trans_status == "Rejected"
  //       ) {
  //         setArchivable(false);
  //       }
  //     } else if (
  //       folio.tran_form_type == "STP" &&
  //       folio.trans_status != "Discarded"
  //     ) {
  //       stpAmount += folio.tran_caluclate_amount;
  //       setStpAmountTotal(folio.tran_caluclate_amount);
  //       if (
  //         folio.trans_status == "Processing" ||
  //         folio.trans_status == "Failed" ||
  //         folio.trans_status == "Pending" ||
  //         folio.trans_status == "Rejected"
  //       ) {
  //         setArchivable(false);
  //       }
  //     } else if (
  //       folio.tran_form_type == "Redeem" &&
  //       folio.trans_status != "Discarded"
  //     ) {
  //       redeemAmount += folio.tran_no_of_unites;
  //       setRedeemAmountTotal(folio.tran_no_of_unites);
  //       if (
  //         folio.trans_status == "Processing" ||
  //         folio.trans_status == "Failed" ||
  //         folio.trans_status == "Pending" ||
  //         folio.trans_status == "Rejected"
  //       ) {
  //         setArchivable(false);
  //       }
  //     }
  //     if (
  //       folio.trans_status == "Postponed" &&
  //       folio.tran_form_type == "Stop_sip"
  //     ) {
  //       setIsPostponed(true);
  //     }

  //     if (goalName !== folio.goal_name) {
  //       totalAmount = 0;
  //       setGoalName(folio.goalName);
  //     }
  //     totalAmount += 0;
  //   });

  //   setTotals((prevState) => ({
  //     ...prevState,
  //     totalAmount,
  //   }));
  // }, [isArchivedEvent]);

  // const showtransaction = () => {};

  // const openInfo = (folio) => {
  //   const formattedDate = moment(folio.tran_start_date).format("Do MMMM YYYY");

  //   // Conditionally render date content based on folio.tran_form_type
  //   const dateContent =
  //     folio.tran_form_type !== "ReInvest" && folio.tran_form_type !== "Redeem"
  //       ? `<tr>
  //         <td style="width: 7vw; text-align:left; font-weight: 600; padding: 5px;">Start Date:</td>
  //         <td style="text-align:left; padding: 5px;">${formattedDate}</td>
  //       </tr>`
  //       : "";
  //   const accountNoContent =
  //     folio.tran_form_type !== "Stop_sip" &&
  //     folio.tran_form_type !== "Redeem" &&
  //     folio.tran_form_type !== "STP" &&
  //     folio.tran_form_type !== "ReInvest" &&
  //     folio.account_number !== ""
  //       ? `<tr>
  //         <td style="width: 7vw; text-align:left; font-weight: 600; padding: 5px;">Account No:</td>
  //         <td style="text-align:left; padding: 5px;">${folio.account_number}</td>
  //       </tr>`
  //       : "";

  //   // Create the HTML content dynamically
  //   const htmlContent = `
  //     <table style="width: 100%; border-collapse: collapse;">
  //       ${dateContent}
  //       <tr>
  //         <td style="text-align:left; font-weight: 600; padding: 5px;">Email Id:</td>
  //         <td style="text-align:left; padding: 5px;">${folio.client_email}</td>
  //       </tr>
  //       <tr>
  //         <td style="text-align:left; font-weight: 600; padding: 5px;">Mobile:</td>
  //         <td style="text-align:left; padding: 5px;">${folio.folio_mobile}</td>
  //       </tr>
  //       ${accountNoContent}
  //     </table>
  //   `;

  //   // Show the Swal modal
  //   Swal.fire({
  //     title: "Investor Information",
  //     html: htmlContent,
  //     confirmButtonText: "Close",
  //     customClass: {
  //       confirmButton: "swal-confirm-btn",
  //     },
  //     didOpen: () => {
  //       // Any additional actions after the modal opens (optional)
  //     },
  //   });
  // };

  const getGoalMessage = (folios, goalName, goalYear) => {
    const selectedFolios = folios.filter((folio) => folio.isChecked);

    // --- Total Amount Calculation (same as PHP) ---
    const totalAmount = selectedFolios.reduce((sum, f) => {

      const d = Number(f.goal_folio_trans?.sipDeficit) || 0;
      const minus =
        (f.tran_form_type === "Redeem" || f.tran_form_type === "Stop_sip") &&
        f.trans_status !== "Discarded";
      return sum + (minus ? -d : d);
    }, 0);


    // Format INR and ensure absolute value for negative case
    const formattedAmount = formatRupees(Math.abs(totalAmount));
    console.log("totalAmount", folios, totalAmount, formattedAmount, goalName);

    // Check if it’s a "common goal" (for text “your” or not)
    const isCommonGoal =
      goalName.includes("Marriage") ||
      goalName.includes("Graduation") ||
      goalName.includes("Post Graduation");
    const yours =
      isCommonGoal || goalName.trim().split(" ").length <= 1 ? "" : " your";

    // --- Unmapped Goals ---
    if (goalName === "Unmapped Folio" || goalName === "Unmapped Folios") {
      return (
        <div className="alert alert-warning">
          <strong>Note:</strong> This folio is not mapped to any goal.
        </div>
      );
    }

    // --- Current Year Goals ---
    if (goalYear === new Date().getFullYear().toString()) {
      return (
        <div className="row bg-light">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Success"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              <b>Congratulations,</b> you have successfully achieved{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal.
            </p>
          </div>
        </div>
      );
    }

    // --- Positive Impact (add) ---
    if (totalAmount > 0) {
      return (
        <div className="row">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Success"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              This Goal Event will add a total of{" "}
              <span className="fs-14 fw-semibold clrgreen">
                {formattedAmount}
              </span>{" "}
              to{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal
              by the year{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalYear}</span>.{" "}
              <b>Congratulations!</b>
            </p>
          </div>
        </div>
      );
    }

    // --- Negative Impact (subtract) ---
    if (totalAmount <= 0) {
      return (
        <div className="row bg-light">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Warning"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              This Goal Event could potentially impact{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal
              by{" "}
              <span className="fs-14 fw-semibold clrgreen">
                {formattedAmount}
              </span>
              . But don't worry, there are plenty of tools and techniques
              available to cover this gap in the years to come! We’ll connect
              again soon to discuss an action plan for the same.
            </p>
          </div>
        </div>
      );
    }

    // --- Default Fallback ---
    return (
      <div className="alert alert-info">
        No specific details available for this goal.
      </div>
    );
  };


  useEffect(() => {
    socket.on("createCon", (msg) => {
      console.log("📥 Received from socket → createCon:", msg);
      const { type, payload } = msg.data || {};

      if (type === "checkbox-update") {
        const { goalName, transId, isChecked } = payload;

        setGroupedFoliosState((prev) => {
          const updated = { ...prev };
          if (!updated[goalName]) return prev;

          updated[goalName] = updated[goalName].map((folio) =>
            folio.transId === transId ? { ...folio, isChecked } : folio
          );
          return updated;
        });
      }

      if (type === "select-all-update") {
        const { goalName, isChecked } = payload;

        setGroupedFoliosState((prev) => {
          const updated = { ...prev };
          if (!updated[goalName]) return prev;

          updated[goalName] = updated[goalName].map((folio) => ({
            ...folio,
            isChecked,
          }));
          return updated;
        });
      }
    })
  }, []);


  const handleCheckboxChange = (goalName, transId, isChecked) => {
    setGroupedFoliosState((prev) => {
      const updated = { ...prev };
      updated[goalName] = updated[goalName].map((folio) =>
        folio.transId === transId ? { ...folio, isChecked } : folio
      );
      return updated;
    });
  };
  // Handle Select All checkbox toggle
  const handleSelectAll = (goalName, isChecked) => {
    setGroupedFoliosState((prev) => {
      const updated = { ...prev };
      updated[goalName] = updated[goalName].map((folio) => ({
        ...folio,
        isChecked,
      }));
      return updated;
    });
  };




  // const regenerate = () => {};

  // const handelShowFooter = (folio) => {
  //   const currentYear = new Date().getFullYear();
  //   const goalName = folio.goal_name || "";
  //   const goalYear = folio.goalYear || "0";
  //   let totalAmount = 5;

  //   // Calculate totalAmount based on transaction type and status
  //   if (
  //     folio.tran_form_type === "Redeem" ||
  //     folio.tran_form_type === "Stop_sip"
  //   ) {
  //     if (folio.trans_status !== "Discarded" && folio.sipDeficit) {
  //       totalAmount -= Number(folio.sipDeficit) || 0;
  //     }
  //   } else {
  //     if (folio.sipDeficit) {
  //       totalAmount += Number(folio.sipDeficit) || 0;
  //     }
  //   }
  //   console.log("totalAmount", totalAmount, goalYear);

  //   // Format totalAmount as INR currency
  //   const formattedAmount = Math.abs(totalAmount)?.toLocaleString("en-IN", {
  //     style: "currency",
  //     currency: "INR",
  //   });

  //   // Determine the possessive form ("your" or "")
  //   const hasSpecialGoal =
  //     goalName.includes("Marriage") ||
  //     goalName.includes("Graduation") ||
  //     goalName.includes("Post Graduation");
  //   const yours = hasSpecialGoal ? "" : " your";

  //   // Handle unmapped folios
  //   if (goalName === "Unmapped Folio" || goalName === "Unmapped Folios") {
  //     return (
  //       <div className="alert alert-warning">
  //         <strong>Note:</strong> This folio is not mapped to any goal.
  //       </div>
  //     );
  //   }

  //   // Handle goals achieved in the current year
  //   if (parseInt(goalYear, 10) === currentYear) {
  //     return (
  //       <div className="row bg-light">
  //         <div className="col-md-2">
  //           <img
  //             src="assets/images/Goal-Event.svg"
  //             alt="Success"
  //             style={{ width: "6.2vw" }}
  //           />
  //         </div>
  //         <div className="col-md-10 pt-3 ">
  //           <p className="fs-14 fw-normal text-center w-50 mx-auto">
  //             <b>Congratulations,</b> you have successfully achieved{yours}{" "}
  //             <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
  //             goal.
  //           </p>
  //         </div>
  //       </div>
  //     );
  //   }

  //   // Handle positive or negative totalAmount
  //   if (totalAmount > 0) {
  //     return (
  //       <div className="row ">
  //         <div className="col-md-2">
  //           <img
  //             src="assets/images/Goal-Event.svg"
  //             alt="Success"
  //             style={{ width: "6.2vw" }}
  //           />
  //         </div>
  //         <div className="col-md-10 pt-3">
  //           <p className="fs-14 fw-normal text-center w-50 mx-auto">
  //             This Goal Event could potentially add a total of{" "}
  //             <span className="fs-14 fw-semibold clrgreen">
  //               {formattedAmount}
  //             </span>{" "}
  //             to{yours}{" "}
  //             <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
  //             goal by the year{" "}
  //             <span className="fs-14 fw-semibold clrgreen">{goalYear}</span>.{" "}
  //             <b>Congratulations!</b>
  //           </p>
  //         </div>
  //       </div>
  //     );
  //   } else if (totalAmount < 0) {
  //     return (
  //       <div className="row bg-light">
  //         <div className="col-md-2">
  //           <img
  //             src="assets/images/Goal-Event.svg"
  //             alt="Warning"
  //             style={{ width: "6.2vw" }}
  //           />
  //         </div>
  //         <div className="col-md-10 pt-3">
  //           <p className="fs-14 fw-normal text-center w-50 mx-auto">
  //             This Goal Event could potentially impact{yours}{" "}
  //             <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
  //             goal by{" "}
  //             <span className="fs-14 fw-semibold clrgreen">
  //               {formattedAmount}
  //             </span>
  //             . But don't worry, there are plenty of tools and techniques
  //             available to cover this gap in the years to come! We’ll connect
  //             again soon to discuss an action plan for the same.
  //           </p>
  //         </div>
  //       </div>
  //     );
  //   }

  //   // Default fallback
  //   return (
  //     <div className="alert alert-info">
  //       No specific details available for this goal.
  //     </div>
  //   );
  // };

  // const handleResend = () => {
  //   setShowResendModal(true);
  // };




  return (
    <>
      <div className="row">
        <div className="col">
          {isArchivedEvent.length > 0 &&
            isArchivedEvent?.[0]?.message !== "No initiated folios found." ? (
            <div className="scroll-container">

              {Object.entries(groupedFoliosState).map(([goalName, folios]) => {

                const stpFolios = folios.filter(f => f.tran_form_type === "STP");
                const lumpSumFolios = folios.filter(f => f.tran_form_type === "ReInvest");
                const sipFolios = folios.filter(f => f.tran_form_type === "SIP");
                const redeemFolios = folios.filter(f => f.tran_form_type === "Redeem");
                const sipStopFolios = folios.filter(f => f.tran_form_type === "Stop_sip");
                // const lumpSumFolios = folios.filter(f => f.tran_form_type === "ReInvest");

                const stpTotal = stpFolios.reduce((acc, f) => acc + Number(f.tran_caluclate_amount || 0), 0);
                const lumpSumTotal = lumpSumFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                const sipTotal = sipFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                const redeemTotal = redeemFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                const sipStopTotal = sipStopFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);



                console.log("stpTotal", stpFolios, lumpSumFolios, lumpSumTotal);


                return (
                  <div key={goalName}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Investor
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Transaction Type
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Fund Name
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Amount
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            IFSC Code
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Account No.
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            <div className="fs-14 d-flex align-items-center gap-2">
                              <input
                                type="checkbox"
                                checked={folios.every((f) => f.isChecked)}
                              // onChange={(e) => handleSelectAll(goalName, e.target.checked)}
                              />

                              Status
                            </div>
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Remark
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* Goal header row */}
                        <tr className="bgblue">
                          <th colSpan="6">
                            <p className="fs-14 my-2">{goalName}</p>
                          </th>
                        </tr>
                        {stpFolios.length > 0 && (
                          <>
                            {/* <tr>
                            <td colSpan="6" className="bg-light text-primary fw-bold">
                              STP Transactions
                            </td>
                          </tr> */}

                            {stpFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>STP
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 200, hide: 200 }}
                                      overlay={
                                        <Tooltip
                                          id={`tooltip-${index}`}
                                          style={{
                                            ['--bs-tooltip-max-width']: '520px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Start Date:</span>
                                            <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                              "MMMM D, YYYY"
                                            )}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Email Id:</span>
                                            <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                          </div>



                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Mobile:</span>
                                            <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Client Code:</span>
                                            <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                          </div>

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Account No:</span>
                                            <span className="fw-normal">
                                              {folio?.account_number
                                                ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                                : "****"}
                                            </span>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                        <IoInformationCircleOutline />
                                      </span>
                                    </OverlayTrigger>
                                  </td>
                                  <td>{folio.tran_fund_name || folio.tran_out_fund}</td>
                                  <td>{formatRupees(folio.tran_caluclate_amount || 0)}</td>
                                  <td>{folio.ifsc_code}</td>
                                  <td>{folio.account_number}</td>
                                  <td className="d-flex align-items-center gap-2">
                                    <label className="container1" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        checked={folio.isChecked || false}
                                      // onChange={(e) =>
                                      //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                      // }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                    {folio.trans_status}
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="3" className="text-end fw-semibold">STP Total:</td>
                              <td>{formatRupees(stpTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        {lumpSumFolios.length > 0 && (
                          <>
                            {/* <tr>
                            <td colSpan="6" className="bg-light text-success fw-bold">
                              Lump Sum Transactions
                            </td>
                          </tr> */}

                            {lumpSumFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>Lump Sum
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 200, hide: 200 }}
                                      overlay={
                                        <Tooltip
                                          id={`tooltip-${index}`}
                                          style={{
                                            ['--bs-tooltip-max-width']: '520px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Start Date:</span>
                                            <span className="fw-normal">
                                              {moment(folio?.created_at).format(
                                              "MMMM D, YYYY"
                                            )}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Email Id:</span>
                                            <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                          </div>



                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Mobile:</span>
                                            <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Client Code:</span>
                                            <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                          </div>

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Account No:</span>
                                            <span className="fw-normal">
                                              {folio?.account_number
                                                ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                                : "****"}
                                            </span>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                        <IoInformationCircleOutline />
                                      </span>
                                    </OverlayTrigger>

                                  </td>
                                  <td>{folio.tran_fund_name}</td>
                                  <td>{formatRupees(folio.tran_no_of_unites || 0)}</td>
                                  <td>{folio.ifsc_code}</td>
                                  <td>{folio.account_number}</td>
                                  <td className="d-flex align-items-center gap-2">
                                    <label className="container1" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        checked={folio.isChecked || false}
                                      // onChange={(e) =>
                                      //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                      // }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                    {folio.trans_status}
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="3" className="text-end fw-semibold">Lump Sum Total:</td>
                              <td>{formatRupees(lumpSumTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        {sipFolios.length > 0 && (
                          <>

                            {sipFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>SIP  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 200, hide: 200 }}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${index}`}
                                        style={{
                                          ['--bs-tooltip-max-width']: '520px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Start Date:</span>
                                          <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                            "MMMM D, YYYY"
                                          )}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Email Id:</span>
                                          <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                        </div>



                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Mobile:</span>
                                          <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Client Code:</span>
                                          <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                        </div>

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Account No:</span>
                                          <span className="fw-normal">
                                            {folio?.account_number
                                              ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                              : "****"}
                                          </span>
                                        </div>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline />
                                    </span>
                                  </OverlayTrigger></td>
                                  <td>{folio.tran_fund_name}</td>
                                  <td>{formatRupees(folio.tran_no_of_unites || 0)}</td>
                                  <td>{folio.ifsc_code}</td>
                                  <td>{folio.account_number}</td>
                                  <td className="d-flex align-items-center gap-2">
                                    <label className="container1" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        checked={folio.isChecked || false}
                                      // onChange={(e) =>
                                      //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                      // }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                    {folio.trans_status}
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="3" className="text-end fw-semibold">Sip Total:</td>
                              <td>{formatRupees(sipTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        {sipStopFolios.length > 0 && (
                          <>

                            {sipStopFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td> SIP Stop <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 200, hide: 200 }}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${index}`}
                                        style={{
                                          ['--bs-tooltip-max-width']: '520px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Start Date:</span>
                                          <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                            "MMMM D, YYYY"
                                          )}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Email Id:</span>
                                          <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                        </div>



                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Mobile:</span>
                                          <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Client Code:</span>
                                          <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                        </div>

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Account No:</span>
                                          <span className="fw-normal">
                                            {folio?.account_number
                                              ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                              : "****"}
                                          </span>
                                        </div>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline />
                                    </span>
                                  </OverlayTrigger></td>
                                  <td>{folio.tran_fund_name}</td>
                                  <td>{formatRupees(folio.tran_no_of_unites)}</td>
                                  <td>{folio.ifsc_code}</td>
                                  <td>{folio.account_number}</td>
                                  <td className="d-flex align-items-center gap-2">
                                    <label className="container1" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        checked={folio.isChecked || false}
                                      // onChange={(e) =>
                                      //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                      // }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                    {folio.trans_status}
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="3" className="text-end fw-semibold">Sip Stop Total:</td>
                              <td>{formatRupees(sipStopTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        {redeemFolios?.length > 0 && (
                          <>
                            {redeemFolios?.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>
                                    Redeem
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 200, hide: 200 }}
                                      container={typeof document !== 'undefined' ? document.body : undefined}
                                      popperConfig={{
                                        strategy: 'fixed',
                                        modifiers: [{ name: 'preventOverflow', options: { boundary: 'viewport' } }],
                                      }}
                                      overlay={
                                        <Tooltip
                                          id={`tooltip-${index}`}
                                          style={{
                                            ['--bs-tooltip-max-width']: '520px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Start Date:</span>
                                            <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                              "MMMM D, YYYY"
                                            )}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Email Id:</span>
                                            <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Mobile:</span>
                                            <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Client Code:</span>
                                            <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                          </div>

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Account No:</span>
                                            <span className="fw-normal">
                                              {folio?.account_number
                                                ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                                : "****"}
                                            </span>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span className="clrgreen ms-1" style={{ cursor: 'pointer' }}>
                                        <IoInformationCircleOutline />
                                      </span>
                                    </OverlayTrigger>
                                  </td>


                                  <td>{folio.tran_fund_name}</td>
                                  <td>{formatRupees(folio.tran_no_of_unites)}</td>
                                  <td>{folio.ifsc_code}</td>
                                  <td>{folio.account_number}</td>
                                  <td className="d-flex align-items-center gap-2">
                                    <label className="container1" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        checked={folio.isChecked || false}
                                      // onChange={(e) =>
                                      //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                      // }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                    {folio.trans_status}
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="3" className="text-end fw-semibold">Sip Total:</td>
                              <td>{formatRupees(redeemTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}


                        {/* {folios.map((folio, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{folio.investor_name}</td>

                            <td>
                              {folio.tran_financial_document_type ===
                              "ReInvest" ? (
                                "Lump Sum"
                              ) : folio.tran_form_type === "SIP" &&
                                ["Pending", "Failed", "Rejected"].includes(
                                  folio.trans_status
                                ) ? (
                                <span onClick={() => showtransaction()}>
                                  SIP
                                </span>
                              ) : (
                                folio.tran_financial_document_type
                              )}

                              <IoInformationCircleOutline
                                className="ms-2"
                                onClick={() => openInfo(folio)}
                              />
                            </td>

                            <td>
                              <span>{folio.tran_fund_name||folio.tran_out_fund}</span>
                              
                              {["ReInvest", "SIP", "STP"].includes(
                                folio.tran_form_type
                              ) && (
                                <>
                                  <IoInformationCircleOutline
                                    className="ms-2"
                                    onClick={() =>
                                      showFundDetails(
                                        folio.scheme_code,
                                        folio.goal_name,
                                        folio.goalYear,
                                        folio.tran_fund_name
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                  <FundDetailsModal
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                    content={modalContent}
                                  />
                                </>
                              )}
                            </td>

                            <td>
                              ₹{" "}
                              {folio.tran_form_type === "STP"
                                ? folio?.tran_caluclate_amount?.toLocaleString()
                                : folio?.tran_no_of_unites?.toLocaleString()}
                            </td>
                            <td className="d-flex align-items-center gap-2">
                            <label
                                  className="container1"
                                  style={{
                                    margin: 0,
                                    pointerEvents: [
                                      "Executed",
                                      "Processing",
                                    ].includes(folio.trans_status)
                                      ? "none"
                                      : "auto",
                                  }}
                                >
                            <input
                                type="checkbox"
                                id={`checkbox-${folio.transId}`}
                                checked={folio.isChecked || false}
                                // onChange={(e) =>
                                //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                // }
                                disabled={["Executed", "Processing", "Awaiting Auth"].includes(folio.trans_status)}
                                aria-labelledby={`label-${folio.transId}`}
                                data-units={
                                  folio.tran_form_type === "STP"
                                    ? folio.tran_caluclate_amount
                                    : folio.tran_no_of_unites
                                }
                                data-transid={folio.transId}
                                data-goalname={goalName.replace(/\s/g, "")}
                                data-goal_name={goalName}
                                data-goalyear={folio.goalYear}
                                data-deficit={folio.sipDeficit}
                                data-type={folio.tran_form_type}
                                />
                                 <span
                                    className="checkmark"
                                    style={{
                                      pointerEvents: "none",
                                      backgroundColor: [
                                        "Executed",
                                        "Processing",
                                      ].includes(folio.trans_status)
                                        ? "#596958"
                                        : "",
                                    }}
                                  >

                                  </span>
                                  </label>
                                  {folio.trans_status}
                              {[
                                "Processing",
                                "Awaiting Auth",
                                "Failed",
                                "Rejected",
                                "Postponed",
                              ].includes(folio.trans_status) &&
                                folio.tran_form_type === "ReInvest" && (
                                  <span
                                    id="regenerate"
                                    onClick={() => regenerate()}
                                  >
                                    <IoMdRefresh />
                                  </span>
                                )}

                            </td>
                            <td>
                              {folio.trans_status === "Executed"
                                ? "ALLOTMENT DONE"
                                : folio.bse_response}
                            </td>
                          </tr>

                        
                        </React.Fragment>
                      ))} */}
                        {/* <>
                              <tr>
                              <td colSpan="3" className="text-end fw-semibold">Lump Sum Total:</td>
                              <td>₹ {lumpSumTotal.toLocaleString()}</td>
                              <td colSpan="2"></td>
                            </tr>
                            <tr>
                              <td colSpan="3" className="text-end fw-semibold">STP Start Total:</td>
                              <td>₹ {stpTotal.toLocaleString()}</td>
                              <td colSpan="2"></td>
                            </tr>
                            </> */}
                        {/* Footer Message Row (replaces handelShowFooter) */}
                        {!isViewArchivedEvent && (
                          <tr disabled={goalName === "Unmapped Folio"}>
                            <td colSpan="7">
                              {getGoalMessage(
                                folios,
                                goalName,
                                folios[0]?.goalYear || ""
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                );
              })}
            </div>
          ) : (
            <Alert
              variant="success"
              className="fw-bold d-block text-center mt-4"
            >
              No Goal Event
            </Alert>
          )}
        </div>
      </div>
      {isPostponed && (
        <div className="col-sm-12  mt-3">
          <div className=" alert alert-warning ">
            Alert! Some SIP Stops will be processed after the next
            debit as less than 9 days remain until the next debit
            date.
          </div>
        </div>
      )}

      {!isViewArchivedEvent && (
        <div class="row pt-3">
          <div class="col text-end">
            <p class="fs-14 fw-normal Total">
              <div className="d-flex gap-4 justify-content-end">
                {sipStartTotal !== 0 && (
                  <p>
                    SIP Start{" "}
                    <span class="fs-14 fw-semibold">₹ {sipStartTotal}</span>
                  </p>
                )}
                {lumpsumAmountTotal !== 0 && (
                  <p>
                    Lump Sum Amount{" "}
                    <span class="fs-14 fw-semibold">
                      ₹ {lumpsumAmountTotal}
                    </span>
                  </p>
                )}
                {sipStopTotal !== 0 && (
                  <p>
                    SIP Stop{" "}
                    <span class="fs-14 fw-semibold">₹ {sipStopTotal}</span>
                  </p>
                )}
                {redeemAmountTotal !== 0 && (
                  <p>
                    Redemption Amount{" "}
                    <span class="fs-14 fw-semibold">₹ {redeemAmountTotal}</span>
                  </p>
                )}
                {stpAmountTotal !== 0 && (
                  <p>
                    STP Amount{" "}
                    <span class="fs-14 fw-semibold">₹ {stpAmountTotal}</span>
                  </p>
                )}

              </div>
            </p>
          </div>
        </div>
      )}

      {/* <ResendModal
        show={showResendModal}
        onHide={() => setShowResendModal(false)}
        roomId={roomId}
        isEventId={isEventId}
      /> */}
    </>
  );
};
